import type { VerificationSummary } from './verification'

/** Transcribed from docs/v5/backend-accuracy.md; no unmatched columns are compared.
 * This is a historical national study, not a local or automatically refreshed score.
 * Baseline biases were not published. Paired fusion bias is also unknown when its
 * case count differs from full fusion, so those values deliberately remain null.
 */
export const publishedVerification: VerificationSummary = {
  schema: 'wf-verification-summary.v1', kind: 'published-study', generated_at: null,
  scope: { id: 'national', label: 'National airport sample', observations: 'IEM ASOS routine METARs' },
  window: { from: '2026-10-10', to: '2026-10-18' }, pairing: 'station-valid-issue',
  best_single_min_coverage: 0.8, evidence: 'docs/v5/backend-accuracy.md',
  temperature: [
    { lead_hours: [0, 6], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws'], samples: 1208, fusion: { mae_c: 0.7311, bias_c: -0.0302 }, baseline: { mae_c: 1.1622, bias_c: null } },
      { id: 'icon', name: 'ICON', roles: ['best_single'], samples: 1089, fusion: { mae_c: 0.7317, bias_c: null }, baseline: { mae_c: 1.1564, bias_c: null } },
    ] },
    { lead_hours: [6, 24], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws', 'best_single'], samples: 4201, fusion: { mae_c: 0.9326, bias_c: 0.0040 }, baseline: { mae_c: 1.1757, bias_c: null } },
    ] },
    { lead_hours: [24, 48], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws', 'best_single'], samples: 4978, fusion: { mae_c: 1.0046, bias_c: -0.1045 }, baseline: { mae_c: 1.3016, bias_c: null } },
    ] },
    { lead_hours: [48, 72], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws'], samples: 4308, fusion: { mae_c: 1.1428, bias_c: -0.0975 }, baseline: { mae_c: 1.3990, bias_c: null } },
      { id: 'ecmwf_aifs', name: 'ECMWF AIFS', roles: ['best_single'], samples: 3928, fusion: { mae_c: 1.0888, bias_c: null }, baseline: { mae_c: 1.3987, bias_c: null } },
    ] },
    { lead_hours: [72, 96], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws'], samples: 3636, fusion: { mae_c: 1.2973, bias_c: -0.1146 }, baseline: { mae_c: 1.5790, bias_c: null } },
      { id: 'ecmwf_aifs', name: 'ECMWF AIFS', roles: ['best_single'], samples: 3276, fusion: { mae_c: 1.2459, bias_c: null }, baseline: { mae_c: 1.5151, bias_c: null } },
    ] },
    { lead_hours: [96, 120], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws', 'best_single'], samples: 2964, fusion: { mae_c: 1.4357, bias_c: -0.1379 }, baseline: { mae_c: 1.6842, bias_c: null } },
    ] },
    { lead_hours: [120, 144], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws'], samples: 2293, fusion: { mae_c: 1.6226, bias_c: -0.0911 }, baseline: { mae_c: 1.9768, bias_c: null } },
      { id: 'ecmwf_aifs', name: 'ECMWF AIFS', roles: ['best_single'], samples: 1996, fusion: { mae_c: 1.6539, bias_c: null }, baseline: { mae_c: 1.8512, bias_c: null } },
    ] },
    { lead_hours: [144, 168], comparisons: [
      { id: 'nws', name: 'NWS', roles: ['nws'], samples: 1613, fusion: { mae_c: 1.7112, bias_c: null }, baseline: { mae_c: 2.2130, bias_c: null } },
      { id: 'ecmwf_aifs', name: 'ECMWF AIFS', roles: ['best_single'], samples: 1623, fusion: { mae_c: 1.7153, bias_c: -0.0958 }, baseline: { mae_c: 1.9598, bias_c: null } },
    ] },
  ],
}
